import { Box, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import EmptyPage from "./EmptyPage";

const NoVideo = () => {
  const navigate = useNavigate();
  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={12} lg={6}>
          <Box
            sx={{
              width: 1,
              height: "80vh",
              backgroundImage: "url(/images/layout/photos.png)",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              position: "relative",

              display: "flex",
              justifyContent: "center",
              alignItems: "start",
              flexDirection: "column",
            }}
          >
            <Box sx={{ position: "absolute", top: 250, left: 50 }}>
              <Typography color={"#F2F2F2"} variant="subtitle1">
                Interactive video
              </Typography>
              <Typography color={"#FFFFFF"} variant="h4" fontWeight={700}>
                Unlimited creativity
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Box
            sx={{
              display: "grid",
              placeItems: "center",
              height: 1,
              width: 1,
              borderRadius: 3,
              bgcolor: "#F5F5F5",
            }}
          >
            <EmptyPage
              title={"There are no videos previously created"}
              image={"/images/camera.svg"}
              boxSx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 3,
                width: 1,
                height: 1,
              }}
              imageStyle={{ maxWidth: "205px", width: "100%" }}
              onClick={() => navigate("/create-video")}
              buttonText={"Create Interactive Videos"}
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default NoVideo;
